// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"n0z2t___Triptych-module__sliderContainer"};